import { render } from "./BlackListView.vue?vue&type=template&id=a401aece&scoped=true"
import script from "./BlackListView.vue?vue&type=script&lang=js"
export * from "./BlackListView.vue?vue&type=script&lang=js"

import "./BlackListView.vue?vue&type=style&index=0&id=a401aece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a401aece"]])

export default __exports__